import { render, staticRenderFns } from "./ManageBook.vue?vue&type=template&id=39006dc4&scoped=true"
import script from "./ManageBook.vue?vue&type=script&lang=js"
export * from "./ManageBook.vue?vue&type=script&lang=js"
import style1 from "./ManageBook.vue?vue&type=style&index=1&id=39006dc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39006dc4",
  null
  
)

export default component.exports